var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonsLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "87px",
    height: "90px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#6C5DD3",
    d: "M 4.5,-0.5 C 26.1667,-0.5 47.8333,-0.5 69.5,-0.5C 71.475,0.646381 72.975,2.31305 74,4.5C 74.4999,16.4954 74.6665,28.4954 74.5,40.5C 57.9021,38.7155 46.0688,45.3821 39,60.5C 36.0821,70.4363 37.5821,79.603 43.5,88C 30.5,88.6667 17.5,88.6667 4.5,88C 2.31305,86.975 0.646381,85.475 -0.5,83.5C -0.5,57.1667 -0.5,30.8333 -0.5,4.5C 0.833333,2.5 2.5,0.833333 4.5,-0.5 Z M 18.5,8.5 C 26.1667,8.5 33.8333,8.5 41.5,8.5C 41.6665,18.5056 41.4998,28.5056 41,38.5C 37.3175,36.4928 33.6508,34.4928 30,32.5C 26.3492,34.4928 22.6825,36.4928 19,38.5C 18.5002,28.5056 18.3335,18.5056 18.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#6C5DD3",
    d: "M 86.5,66.5 C 86.5,68.5 86.5,70.5 86.5,72.5C 83.7216,81.6126 77.7216,87.2793 68.5,89.5C 67.5,89.5 66.5,89.5 65.5,89.5C 54.4721,87.4687 48.1388,80.8021 46.5,69.5C 49.1836,53.9691 58.1836,47.8024 73.5,51C 80.2791,54.2659 84.6124,59.4326 86.5,66.5 Z M 74.5,61.5 C 76.0847,62.0024 76.5847,63.0024 76,64.5C 71.6667,68.8333 67.3333,73.1667 63,77.5C 61,75.5 59,73.5 57,71.5C 56.4372,70.2752 56.7705,69.2752 58,68.5C 59.6667,70.1667 61.3333,71.8333 63,73.5C 67.037,69.631 70.8704,65.631 74.5,61.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonsLogo1);
export default __webpack_public_path__ + "static/media/lessonsLogo1.712275944d48d37fa6348e31a614e1b0.svg";
export { ForwardRef as ReactComponent };